import { render, staticRenderFns } from "./ForumPollNumber.vue?vue&type=template&id=7c5c10c9&scoped=true"
import script from "./ForumPollNumber.vue?vue&type=script&lang=js"
export * from "./ForumPollNumber.vue?vue&type=script&lang=js"
import style0 from "./ForumPollNumber.vue?vue&type=style&index=0&id=7c5c10c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5c10c9",
  null
  
)

export default component.exports